import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex align-items-center justify-content-between mt-3",
  style: {"height":"22px","max-width":"280px"}
}
const _hoisted_2 = { class: "flex align-items-center w-full pr-3" }
const _hoisted_3 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Checkbox, {
        id: 'product_' + _ctx.id,
        modelValue: _ctx.compare,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.compare) = $event)),
        binary: true
      }, null, 8, ["id", "modelValue"]),
      _createElementVNode("label", {
        for: 'product_' + _ctx.id,
        class: "ml-2 cursor-pointer text-color-um-blue"
      }, _toDisplayString(_ctx.t("content.globalAddToCompareButton")), 9, _hoisted_3)
    ]),
    _createVNode(_component_Button, {
      icon: "pi pi-eye",
      class: "p-button-rounded p-button-text",
      style: {"font-size":"18px"},
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToComparisons()))
    })
  ]))
}